import {styled} from 'styled-components'

export const WrapperContainer = styled.div`
  position: absolute;
  right: 10px;
  top: 10px;
  width: 220px;
`
